import * as React from 'react';
import {Svg, Rect, Path} from 'react-native-svg';

const RecentReadingsIcon = props => {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Rect width={24} height={24} rx={2} fill="#F90" />
      <Path
        d="M12.833 14.5a.833.833 0 100 1.667.833.833 0 000-1.667zM10.333 16.167a.833.833 0 100 1.666.833.833 0 000-1.666z"
        fill="#fff"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.078 4.708H9.083a.625.625 0 100 1.25H9.3v4.24a6.042 6.042 0 01-1.046 3.397l-2.578 3.79a1.546 1.546 0 001.105 2.407c3.468.39 6.97.39 10.438 0a1.546 1.546 0 001.105-2.406l-2.578-3.79a6.042 6.042 0 01-1.046-3.399V5.958h.217a.625.625 0 100-1.25h-.84zM6.92 18.55c3.375.38 6.783.38 10.158 0a.296.296 0 00.212-.461l-2.578-3.79a7.282 7.282 0 01-.493-.84H9.78c-.145.289-.31.57-.493.84l-2.578 3.79a.296.296 0 00.212.46zm3.346-6.342h3.466a7.294 7.294 0 01-.283-2.01v-4.24h-2.9v4.24a7.29 7.29 0 01-.283 2.01z"
        fill="#fff"
      />
    </Svg>
  );
};

export default RecentReadingsIcon;
